import UltMeta, { Meta } from "./UltMeta/index";
// 客户定义

class Role extends UltMeta {
    CUSTOMER = new Meta(1, "采购商");
    SUPPLIER = new Meta(2, "供应商");
    SUPPLY_CHAIN = new Meta(3, "联合购销商");
    CARRIER = new Meta(4, "承运商");
}
export const ROLE = new Role();

// 子账号权限
class Permission extends UltMeta {
    // 进销存角色 1-10,17
    CONTRACT = new Meta(1, "进销存合同专员");
    PAYMENT = new Meta(2, "进销存资金专员");
    FREIGHT = new Meta(3, "进销存订单专员");
    SHIPMENT = new Meta(17, "进销存发货专员");
    SIGNATURE = new Meta(4, "进销存签收专员");
    RECONCILIATION = new Meta(5, "进销存结算专员");
    INVOICE = new Meta(6, "进销存开票专员");
    FINANCING = new Meta(7, "进销存融资专员");
    INVENTORY = new Meta(8, "进销存盘点专员");
    OUTBOUND = new Meta(9, "进销存出库专员");
    SAMPLING = new Meta(10, "进销存抽检专员");

    // 仓储业务角色 11-16
    STOCK_CONTRACT = new Meta(11, "仓储业务合同专员");
    STOCK_OUTBOUND = new Meta(12, "仓储业务出库专员");
    STOCK_INBOUND = new Meta(13, "仓储业务入库专员");
    TRANSFER = new Meta(14, "仓储业务过户专员");
    STOCK_SAMPLING = new Meta(15, "仓储业务抽检专员");
    STOCK_INVENTORY = new Meta(16, "仓储业务盘点专员");

    // 仓储管理角色
    STORE_CONTRACT = new Meta(18, "仓储管理合同专员");
    STORE_OUTBOUND = new Meta(19, "仓储管理出库专员");
    STORE_INBOUND = new Meta(20, "仓储管理入库专员");
}

export const PERMISSION = new Permission();

class State extends UltMeta {
    ACTIVE = new Meta(1, "启用");
    INACTIVE = new Meta(0, "禁用");
}

export const STATE = new State();

class FindType extends UltMeta {
    SHIP_CARRIER = new Meta(1, "船舶关联查询");
    PURCHASE_DEMAND = new Meta(2, "购买意向");
}
export const FIND_TYPE = new FindType();

/**
 * 会员状态
 */
class MemberState extends UltMeta {
    ACTIVE = new Meta(1, "激活");
    EXPIRY = new Meta(2, "过期");
}
export const MEMBER_STATE = new MemberState();

/**
 * 是否有推广资格
 */
class HasPromotion extends UltMeta {
    YES = new Meta(1, "有");
    CLOSED = new Meta(2, "关闭");
    NO = new Meta(3, "没有");
}
export const HAS_PROMOTION = new HasPromotion();

/**
 * 用来区分获取openid配置文件的枚举(链云/链运)
 */
class Origin extends UltMeta {
    CUSTOMER = new Meta(1, "链云");
    CARRIER = new Meta(2, "船务");
}
export const ORIGIN = new Origin();

/**
 * 用来区分用户绑定和更新邮箱状态的枚举
 */
class EmailType extends UltMeta {
    BIND = new Meta(1, "绑定");
    UPDATE = new Meta(2, "更新");
}
export const EMAIL_TYPE = new EmailType();

// 企业身份
class CustomerRoleType extends UltMeta {
    PURCHASE_CUSTOMER = new Meta(1, "采购客户");
    WAREHOUSE_CUSTOMER = new Meta(2, "仓储业务客户");
    WAREHOUSE_MANAGE_CUSTOMER = new Meta(5, "仓储管理客户");
}

export const CUSTOMER_ROLE_TYPE = new CustomerRoleType();
